// src/components/team/TeamHero.jsx
import { motion } from "framer-motion";
import teamIllustration from "../../assets/images/team/team.svg"; // Get from Storyset or UnDraw

const TeamHero = () => {
  return (
    <section className="bg-gradient-to-br from-white via-blue-50 to-purple-50 py-20">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 items-center gap-12">
        {/* Left: Text */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-6 leading-tight">
            Meet the Team Behind the Impact
          </h1>
          <p className="text-lg text-gray-700 mb-6">
            Our passionate professionals lead with purpose, data, and deep experience in community change. Together, we drive meaningful outcomes across CSR, research, training, and more.
          </p>
        </motion.div>

        {/* Right: Illustration */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9 }}
          className="flex justify-center"
        >
          <img
            src={teamIllustration}
            alt="Our Team Illustration"
            className="max-w-md w-full drop-shadow-md"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default TeamHero;
